import { Directive, OnInit, AfterContentChecked, ViewContainerRef, ChangeDetectorRef, Input } from '@angular/core';

import { ColumnMode } from '@swimlane/ngx-datatable/release/types';
import { DatatableComponent } from '@swimlane/ngx-datatable/release/components';

@Directive({
  selector: '[dfNgxDatatable2]'
})
export class NgxDatatable2Directive implements OnInit, AfterContentChecked {
  datatable: DatatableComponent;
  latestTableWidth: number;

  @Input() rowHeight = 44;

  constructor(private _view: ViewContainerRef, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.datatable = (<any>this._view)._data.componentView.component;
    this.initialize(this.datatable);
  }

  ngAfterContentChecked() {
    if (this.datatable && this.datatable.element.clientWidth !== this.latestTableWidth) {
      this.latestTableWidth = this.datatable.element.clientWidth;
      this.datatable.recalculate();
      this.changeDetectorRef.detectChanges();
    }
  }

  private initialize(datatable: DatatableComponent): void {
    datatable.headerHeight = 40;
    datatable.footerHeight = 0;
    datatable.rowHeight = 44;
    datatable.scrollbarH = true;
    datatable.rowHeight = this.rowHeight;
    datatable.columnMode = ColumnMode.force;

    datatable.messages = {
      emptyMessage: 'å½åæ è®°å½ã',
      totalMessage: 'è¡',
      selectedMessage: 'éæ©'
    };
  }
}
